// extracted by mini-css-extract-plugin
export default {"block":"Helpers-block-xy4","blockHalfSpacing":"Helpers-blockHalfSpacing-KXd"};